/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    var $window = $(window),
        //$body = $(document.body),
        $select = $("select:not(.select2-ajax)"),
        $select_ajax = $(".select2-ajax"),
        $chart = $('#chart_div'),
        google_visualization_bool = false;

    $.fn.exists = function() {return $(this).length !== 0; };
    if ($chart.exists() && typeof google !== "undefined") {
        google.load('visualization', '1.1', {packages: ['corechart', 'line']});
        google_visualization_bool = true;
    }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {

          // Select2 [https://select2.github.io/]
          var select2option = function (option) {
                  var flag_ico_url = $(option.element).data('flag'),
                      main_txt = $(option.element).data('main'),
                      info_txt = $(option.element).data('info'),
                      return_html = '';

                  if (flag_ico_url || info_txt) {
                      return_html += flag_ico_url ? '<img src="' + flag_ico_url + '" class="select2-option-flag" /> ' : '';
                      return_html += main_txt ? main_txt : option.text;
                      return_html += info_txt ? ' <span class="select2-option-info">' + info_txt + '</span>' : '';
                      return $('<span>' + return_html + '</span>');
                  } else {
                      return option.text;
                  }
              },
              templateResultAjax = function (repo) {
                  if (repo.loading) {
                      return repo.text;
                  }

                  var return_html = repo.flag_ico_url ? '<img src="' + repo.flag_ico_url + '" class="select2-option-flag" /> ' : '';
                  return_html += repo.main_txt ? repo.main_txt : '';
                  return_html += repo.info_txt ? ' <span class="select2-option-info">' + repo.info_txt + '</span>' : '';
                  return return_html;
              },
              templateSelectionAjax = function (repo) {
                  var return_html = repo.flag_ico_url ? '<img src="' + repo.flag_ico_url + '" class="select2-option-flag" /> ' : '';
                  return_html += repo.main_txt ? repo.main_txt : '';
                  return_html += repo.info_txt ? ' <span class="select2-option-info">' + repo.info_txt + '</span>' : '';
                  return return_html || repo.text;
              },
              select2_start = function() {
                  $select.select2({
                      maximumSelectionLength: 4,
                      templateSelection: select2option,
                      templateResult: select2option
                  });
              },
              select2_ajax_start = function () {
                  $select_ajax.each(function () {
                      var $select = $(this),
                          ajax_object = window[ $(this).data('ajax') ],
                          ajax_data_limit = $(this).data('limit'),
                          ajax_data_model = $(this).data('model');

                      $select.select2({
                          ajax: {
                              type: 'POST',
                              url: ajax_object.url,
                              dataType: 'json',
                              delay: 250,
                              data: function (params) {
                                  return {
                                      nonce: ajax_object.nonce,
                                      action: ajax_object.action,
                                      model: ajax_data_model,
                                      page: params.page || 1,
                                      limit: ajax_data_limit // items per page
                                  };
                              },
                              processResults: function (data, params) {
                                  params.page = params.page || 1;
                                  return {
                                      results: data.items,
                                      pagination: {
                                          more: (params.page * ajax_data_limit) < data.total_count
                                      }
                                  };
                              },
                              cache: true
                          },
                          escapeMarkup: function (markup) { return markup; },
                          minimumInputLength: 0,
                          templateResult: templateResultAjax,
                          templateSelection: templateSelectionAjax
                      });
                  });
              };
          //$.fn.select2.defaults.set('theme', 'bootstrap');
          //$window.smartresize(select2_start);

          select2_start();
          select2_ajax_start();


          // Date Range Picker [http://www.daterangepicker.com/]
          $('.form-control-daterangepicker').each(function () {
              var $rangeField = $(this);

              $rangeField.daterangepicker({
                  "autoApply": true,
                  "ranges": {
                      'ostatnie 7 dni':      [moment().subtract(6, 'days'), moment()],
                      'ostatnie 30 dni':     [moment().subtract(29, 'days'), moment()],
                      'ten miesiąc':         [moment().startOf('month'), moment().endOf('month')],
                      'poprzedni miesiąc':   [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                      'ostatnie 3 miesiące': [moment().subtract(90, 'days'), moment()],
                      'ostatnie pół roku':   [moment().subtract(182, 'days'), moment()],
                      'ostatni rok':         [moment().subtract(365, 'days'), moment()]
                  },
                  "locale": {
                      "format": "DD.MM.YYYY",
                      "fromLabel": "od",
                      "toLabel": "do",
                      "customRangeLabel": "inny zakres",
                      "daysOfWeek": ["N","Pn","Wt","Śr","Cz","Pt","So"],
                      "monthNames": ["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],
                      "firstDay": 1
                  },
                  "linkedCalendars": false,
                  //"startDate": moment().subtract(29, 'days'), // Start: default value - 30 days before
                  //"endDate": moment(), // End: default value - now!
                  "minDate": new Date(2002, 0, 2), // earliest date a user may select
                  "maxDate": moment() // latest date a user may select - now!
              }, function(start, end, label) {
                  //console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
              });
          });


          // Form, change Action attr. by Radio
          $('[data-action]')
              .bind('change', function () {
                  var $radio = $(this),
                      $form = $radio.parents('form'),
                      form_action_url = $radio.data('action');

                  $form.attr('action', form_action_url); // set new value to Action attr. in Form
              });


          // Calculator (homepage)
          var $calculator_form = $('#form-calculator'),
              $calculator_exchange = $('#form-calculator-exchange'),
              $calculator_submit = $('#form-calculator-submit');

          if ($calculator_form.exists()) {
              $calculator_exchange.click(function () {
                  var $calc_from_curr = $('#form-calculator-currency-from'),
                      $calc_to_curr = $('#form-calculator-currency-to'),
                      calc_from_curr_id = $calc_from_curr.val(), // id
                      calc_to_curr_id = $calc_to_curr.val(); // id

                  $calc_from_curr.val(calc_to_curr_id).change();
                  $calc_to_curr.val(calc_from_curr_id).change();
              });
              $calculator_submit.click(function () {
                  var $calculator_result = $('#calculate-result'),
                      calc_from_curr_id = $('#form-calculator-currency-from').val(), // id
                      calc_to_curr_id = $('#form-calculator-currency-to').val(), // id
                      $calc_amount = $('#form-calculator-amount'),
                      calc_amount_val = $calc_amount.val(), // amount
                      $result_from_val = $('#calc-from-val'),
                      $result_from_curr = $('#calc-from-curr'),
                      $result_from_equation = $('#calc-from-eq'),
                      $result_to_val = $('#calc-to-val'),
                      $result_to_curr = $('#calc-to-curr'),
                      $result_to_equation = $('#calc-to-eq'),
                      conversion = 1,
                      curr_round = function(value, pow) {
                          var multiplier = Math.pow(10, pow);
                          return Math.round((value) * multiplier) / multiplier;
                      };

                  if ( currency[calc_from_curr_id] !== 'undefined' && currency[calc_to_curr_id] !== 'undefined') {

                      if (!calc_amount_val || calc_amount_val==='0') {
                          calc_amount_val = 100;
                          $calc_amount.val(calc_amount_val);
                      }
                      conversion = currency[calc_from_curr_id].rate / currency[calc_to_curr_id].rate;
                      reverse_conversion = currency[calc_to_curr_id].rate / currency[calc_from_curr_id].rate;
                      $result_from_val.text(calc_amount_val + ' ' + currency[calc_from_curr_id].iso);
                      $result_from_curr.text(currency[calc_from_curr_id].name);
                      $result_from_equation.text('1 ' + currency[calc_from_curr_id].iso + ' = ' + curr_round(conversion, 4) + ' ' + currency[calc_to_curr_id].iso);
                      $result_to_val.text(curr_round((calc_amount_val * conversion), 2) + ' ' + currency[calc_to_curr_id].iso);
                      $result_to_curr.text(currency[calc_to_curr_id].name);
                      $result_to_equation.text('1 ' + currency[calc_to_curr_id].iso + ' = ' + curr_round(reverse_conversion, 4) + ' ' + currency[calc_from_curr_id].iso);
                      $calculator_result.fadeIn();
                      $('html,body').animate({scrollTop: $calculator_result.offset().top}, 1000);
                  }
              });
          }


          // Charts [https://google-developers.appspot.com/chart/]
          if ($chart.exists() && google_visualization_bool) {

              var hAxis_count = $chart.data('haxis-count') || 6;
              google.setOnLoadCallback(function () {

                  var data = new google.visualization.DataTable(),
                      color = ['#12AAEB'],
                      i = 0;
                  data.addColumn('date', 'Data');
                  if (typeof chart_data_legend !== 'undefined') { // multi charts
                      for (; i < chart_data_legend.length; i+=1) {
                          data.addColumn('number', chart_data_legend[i]);
                      }
                      color = ['#00a651','#DC12EA','#12AAEB','#FF4E56'];
                  } else {
                      data.addColumn('number', 'Kurs');
                  }
                  data.addRows(chart_data); // variable defined in templates

                  var options = {
                      //title: '',
                      width: '100%',
                      //legend: {position: chart_data_legend !== 'undefined' ? 'bottom' : 'none'},
                      legend: {position: 'none'},
                      hAxis: {
                          format: 'd MMM',
                          gridlines: {
                              color: '#D7E4EF', // 'none'
                              count: hAxis_count
                          },
                          viewWindowMode: 'maximized',
                          textStyle: {
                              color: '#395b77'
                          }
                      },
                      vAxis: {
                          //title: 'kurs',
                          baselineColor: '#BACFE0',
                          gridlines: {
                              color: '#BACFE0'
                          },
                          format: '#.##', // # PLN | currency | 0 | decimal
                          //minValue: 0,
                          showTextEvery: 2,
                          textStyle: {
                              color: '#395b77'
                          }
                      },/*
                       trendlines: {
                       0: {
                       type: 'linear',
                       color: 'gray',
                       lineWidth: 1,
                       opacity: 0.1,
                       showR2: true,
                       visibleInLegend: false
                       }
                       },*/
                      chartArea: {
                          left: 40, // 17
                          top: 14,
                          width: '99%',
                          height: 168
                      },
                      colors: color,
                      fontName: 'Open Sans',
                      tooltip: {
                          textStyle: {
                              color: '#395b77'
                          }
                      }
                  };

                  var chart = new google.visualization.LineChart(document.getElementById('chart_div'));
                  chart.draw(data, options);

                  // changes
                  $window.smartresize(function() {
                      chart.draw(data, options);
                  });
                  $('.chart-range').click(function () {
                      var days_number = $(this).data('days');

                      $('.chart-range').removeClass('active');
                      $(this).addClass('active');
                      data = new google.visualization.DataTable();
                      data.addColumn('date', 'Data');
                      if (typeof chart_data_legend !== 'undefined') { // multi charts
                          for (i = 0; i < chart_data_legend.length; i += 1) {
                              data.addColumn('number', chart_data_legend[i]);
                          }
                          color = ['#00a651','#DC12EA','#12AAEB','#FF4E56'];
                      } else {
                          data.addColumn('number', 'Kurs');
                      }
                      data.addRows(chart_data.slice(0, days_number)); // variable defined in templates/content-single-currency.php
                      chart.draw(data, options);
                  });
              });
          }


          // Form Switcher in Archive

          var $form_switcher = $('.form-switcher');
          if ($form_switcher.exists()) {

              var url_hash = window.location.hash;

              $form_switcher.find('.btn').click(function () {
                  var $btn = $(this),
                      $forms_switchable = $('.form-switchable'),
                      $form_target = $($btn.attr('href'));

                  $('.form-switcher .btn').removeClass('active');
                  $btn.addClass('active');
                  $forms_switchable.hide();
                  $form_target.fadeIn();
              });

              if (url_hash) {
                  $('[href="' + url_hash + '"]').click();
              }
          }


          // Table row clickable - links to the current description
          $('tr[data-url]').click(function () {
              location.href = $(this).data('url');
          });


          // Smooth scrolling within page anchors
          $('a[href*=#]')
              .filter(function (index) {
                  return $(this).data('toggle') ? false : true; // we have to turn off "Smooth scrolling" in Collapse elements (Accordion, Toggles)
              })
              .click(function (event) {
                  if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
                      var $target = $(this.hash);
                      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
                      if ($target.length) {
                          //event.preventDefault();
                          $('html,body').animate({scrollTop: $target.offset().top}, 1000);
                      }
                  }
              });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully refer